"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BasicNode_1 = require("./BasicNode");
const validations_1 = require("../validations");
class UserApprovalNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.USER_APPROVAL };
    if (props.type !== types_1.NODE_TYPES.USER_APPROVAL)
      throw new Error("Invalid Node type");
    super(props);
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    let deserializedData = {
      type: types_1.NotificationType.EMAIL,
      approvalEmail: "",
      slackConfig: "",
      message: ""
    };
    if (!nodeData) return deserializedData;
    deserializedData = {
      message: nodeData.message || "",
      type: nodeData.transport.type,
      slackConfig: nodeData.transport.options.slackConfig || "",
      approvalEmail: nodeData.transport.options.approvalEmail || ""
    };
    return deserializedData;
  }
  serialize(uiData) {
    let data = {
      transport: {
        type: uiData.type,
        options: {
          slackConfig: uiData.slackConfig,
          approvalEmail: uiData.approvalEmail
        }
      },
      message: uiData.message
    };
    return data;
  }
  validate() {
    return new validations_1.UserApprovalNodeValidation().validate(this);
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
}
exports.UserApprovalNode = UserApprovalNode;
//# sourceMappingURL=UserApprovalNode.js.map
